let effectObj =
    [
        {
            name: "reverb",
            state: false,
            key: "0"
        },
        {
            name: "delay",
            state: false,
            key: "1"
        },
        {
            name: "stereo",
            state: false,
            key: "2"
        },
        {
            name: "distortion",
            state: false,
            key: "3"
        },
        {
            name: "phaser",
            state: false,
            key: "4"
        },
        {
            name: "chorus",
            state: false,
            key: "5"
        },
        {
            name: "crusher",
            state: false,
            key: "6"
        }
    ]


export default effectObj